export const pheromoneRefillTranslatePaths = {
  title: 'pheromones.pheromone_refill.title',
  select_label: 'pheromones.pheromone_refill.select_label',
  lifespan: 'pheromones.pheromone_refill.lifespan',
  refilled_date: 'pheromones.pheromone_refill.refilled_date',
  button: 'pheromones.pheromone_refill.button',
};
